 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~vsf-category~vsf-checkout~vsf-cms~vsf-compare~vsf-home~vsf-my-account~vsf-product~vsf-top-ba~dee0c57b","3":"vsf-category~vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-related~vsf-rela~610fdd32","4":"vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-product~vsf-search-panel~vsf-~b3ee85fa","5":"vendors~vsf-category~vsf-wp-categories-show~vsf-wp-posts-index~vsf-wp-posts-show","6":"vsf-color-selector-product~vsf-color-wariant-modal~vsf-product-custom-color","7":"vsf-checkout~vsf-microcart","8":"vsf-microcart~vsf-product","9":"SwipeActions","11":"for-download","12":"lang-pl-PL-json","14":"vendors~bodybuilder","15":"vendors~vsf-category","16":"vendors~vsf-checkout","17":"vendors~vsf-graphql","18":"vendors~vsf-search-panel","19":"vsf-account-icon","20":"vsf-async-bottom-sidebar","21":"vsf-async-sidebar","22":"vsf-blog-preview-product","23":"vsf-category","24":"vsf-checkout","25":"vsf-cms","26":"vsf-color-selector-product","27":"vsf-color-wariant-modal","28":"vsf-compare","29":"vsf-compare-icon","30":"vsf-contact-modal","31":"vsf-cookie-notification","32":"vsf-desktop-memu","33":"vsf-error","34":"vsf-footer","35":"vsf-forgotpass","36":"vsf-hamburger-icon","37":"vsf-header","38":"vsf-home","39":"vsf-inner-header","40":"vsf-languages-modal","41":"vsf-layout-default","42":"vsf-login","43":"vsf-mic-icon","44":"vsf-microcart","45":"vsf-microcart-icon","46":"vsf-my-account","47":"vsf-not-found","48":"vsf-order-confirmation","49":"vsf-placepozniej","50":"vsf-product","51":"vsf-product-custom-color","52":"vsf-product-gallery-carousel","53":"vsf-product-gallery-overlay","54":"vsf-product-gallery-zoom-carousel","55":"vsf-product-info-modal","56":"vsf-product-tabs","57":"vsf-register","58":"vsf-related","59":"vsf-related-bestseller","60":"vsf-related-small","61":"vsf-reset-password","62":"vsf-search-adapter-0","63":"vsf-search-adapter-1","64":"vsf-search-panel","65":"vsf-search-panel-desktop","66":"vsf-sidebar-menu","67":"vsf-sign-up","68":"vsf-top-bar","69":"vsf-typ","70":"vsf-wishlist","71":"vsf-wishlist-icon","72":"vsf-wp-categories-index","73":"vsf-wp-categories-show","74":"vsf-wp-posts-index","75":"vsf-wp-posts-show"}[chunkId]||chunkId) + "." + {"0":"f04f7d7182d9fc390971","2":"10c3da239b17e4eab0c5","3":"2c52bc68a6820dfc5a1d","4":"1f42c20459b00e875481","5":"cbe3297f519f785e286a","6":"a81338770f7baf881143","7":"042e893059b240b12936","8":"3156212e3a7fc29d598c","9":"e1ca7efeb1f6b16fe2fa","11":"e1eae47919748c876676","12":"b6ad50f87c9e19a62727","14":"94a53598bae56ee9e1cf","15":"543032217d452fc3e915","16":"b4b1dd20ba66cf9bcb5c","17":"5452166d3b3d4f2a8329","18":"687a0ba57bea4541e00d","19":"2918006eb79271816747","20":"ff34ea815ab175cce151","21":"8cc15502ed2472e6e1c5","22":"8dfbf4e065f61c1b9d53","23":"e791fe7ed961a256f66b","24":"c102224c08ed406993fb","25":"936d91c4e4453cfae040","26":"79d3fcffd31c0b90be3d","27":"95e6d590934bb731f01e","28":"b893036ac783ee5c16be","29":"10543923c11ac77048f6","30":"da69ebc592d909f3f5ec","31":"2881a06b58b1a7d44ad3","32":"ea5a99b33ceab6735ea8","33":"c116fce4d83955431107","34":"f805773bc2c962ddfbb0","35":"e1acfc4b9a82cb3bf06c","36":"ee7b947c2dc51cde42b7","37":"13de998755e950e953bd","38":"663a7997a3b6c9e91519","39":"8094b806465b5fef6b08","40":"816c4a33da2e6b3261a5","41":"88bdf28307aec8187244","42":"623cde8378744106de2e","43":"23396e69f37b14eedeb5","44":"eee46494daea2b8815c2","45":"49ad2886dca59103a136","46":"b3c3d80ccd5bac7fc36c","47":"73e9e7678f980fbd964c","48":"3aed1f4764e8e6419261","49":"caf050390f92b5890e9f","50":"ca9543a11becad491452","51":"e72d89452889ef9e1275","52":"fca27dcf78f53799c4fc","53":"80839ae232a55a84df8d","54":"a354020d07a15a042220","55":"1f59c036b4287ff47029","56":"b3a3c5d08f07397ea490","57":"b910a878cda3feae7901","58":"7844093c16d67831f65a","59":"e3fd9f8c1201d904e1c7","60":"d079921374dc3c3b57b7","61":"0dbbf0de410fc1e92898","62":"ebaf4d4855e1e77ebbc3","63":"76f1e17081c78ad75000","64":"cc0f8b7c051da702adb2","65":"0e4b7335488049f77b77","66":"1f202d2a4e781f99dd38","67":"59c7e15aa4150d27d8a9","68":"0b38ff988d50f1dc854b","69":"eee0042cc3a5b26b1887","70":"f537cbc8a7e567cefd34","71":"83209d1e5b281d9c139e","72":"0bd3d74c3395503876c1","73":"ddfd0e5ba9d15f8d61a3","74":"c26f2de316c8273a6cbd","75":"9346ebc956e09f18a304"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"41": [
 				1,
 				7,
 				8,
 				44,
 				3,
 				4,
 				70,
 				66
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
